import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-third-party-login-header',
    imports: [MatIconModule],
    templateUrl: './third-party-login-header.component.html',
    styleUrl: './third-party-login-header.component.scss',
})
export class ThirdPartyLoginHeaderComponent {}
